"use client";

import { useEffect } from "react";
import Link from "next/link";
import { AlertTriangle } from "lucide-react";

export default function ErrorPage({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-1 flex-col items-center justify-center bg-[#fdf0f4] px-6 py-20 text-center text-zinc-900">
      <AlertTriangle className="mb-6 h-12 w-12 text-[#e0507a]/40" />
      <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[#b8305a]">
        Coś poszło nie tak
      </p>
      <h1 className="mb-4 text-3xl font-bold leading-snug text-zinc-900 lg:text-4xl">
        Napotkaliśmy problem
      </h1>
      <p className="mb-8 max-w-md text-sm leading-relaxed text-zinc-600">
        Spróbuj ponownie za chwilę. Jeśli błąd się powtarza, wróć na stronę główną i spróbuj
        inną drogą.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          onClick={() => unstable_retry()}
          className="rounded-full bg-[#e8607a] px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-[#d4556e]"
        >
          Spróbuj ponownie
        </button>
        <Link
          href="/"
          className="rounded-full border border-[#e0507a] px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-[#e0507a] transition-colors hover:bg-[#e0507a] hover:text-white"
        >
          Strona główna
        </Link>
      </div>
    </div>
  );
}
